import { render } from "./EditTypDOSS.vue?vue&type=template&id=1104fccc"
import script from "./EditTypDOSS.vue?vue&type=script&lang=js"
export * from "./EditTypDOSS.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\Arion\\SATRA\\SATRA_Inzenyring\\inzenyring\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__